import { render, staticRenderFns } from "./OrderQuickMetrics.vue?vue&type=template&id=56c016ae&scoped=true&"
import script from "./OrderQuickMetrics.vue?vue&type=script&lang=js&"
export * from "./OrderQuickMetrics.vue?vue&type=script&lang=js&"
import style0 from "./OrderQuickMetrics.vue?vue&type=style&index=0&id=56c016ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c016ae",
  null
  
)

export default component.exports